import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { stringIsNullOrEmpty } from '../../utils/strings';

export default withStyles({})(({ children, variant, style, className = '' }) => {
    let cssVariant = null;
    if (!stringIsNullOrEmpty(variant)) cssVariant = `flex-container--${variant}`;

    return <div className={`flex-container ${cssVariant || ''} ${className}`} style={style}>{children}</div>;
});
